<template>
  <v-app>
    <!-- Sidebar Navigation -->
    <v-navigation-drawer app v-model="drawer" right
    >
      <v-list>
        <v-list-item @click="goToPage('home')">
           <v-list-item-icon>
            <v-icon>mdi-magnify</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Suche</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="goToPage('profile')">
           <v-list-item-icon>
            <v-icon>mdi-star</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Meine Favoriten</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="goToPage('impressum')">
           <v-list-item-icon>
            <v-icon>mdi-card-account-details</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Impressum</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <!-- App Bar -->
    <v-app-bar 
      app
      elevation="0"
      color="rgba(0,0,0,0)"
      
    >
      <v-toolbar-title></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="drawer = !drawer">
        <v-icon>mdi-menu</v-icon><!-- mdi-dots-vertical-->
      </v-btn>
    </v-app-bar>
    <!-- Main Content -->
    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      drawer: false, // To toggle the sidebar visibility
    };
  },
  methods: {
    goToPage(page) {
      this.$router.push({ name: page });
      this.drawer = false; // Close the drawer when an item is clicked
    },
  },
};
</script>
